export default __webpack_public_path__ + "static/media/globe.d2448b4b.svg";